import { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import "swiper/css";
import "./explore.scss";
import Footer from "../../components/footer/footer";
import CategoryCard from "../../components/category-card/category-card";
import CardImg from "../../assets/cardImg.svg";
import Header from "../../components/header/header";
import Loader from "../../components/loader/loader";
import Image from "../../components/image/image";
import NotFound from "../../assets/NotFound.json";
import Lottie from "lottie-react";
import { pageUrl } from "../../utils/pageConstant";
import { handleExploreOutletName } from "../../utils";
import SearchField from "../../components/search-field/search-field";
import { TwoBtnModal } from "../../components/modal/modal";
import { Carousel } from "react-responsive-carousel";
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import GetRestaurantsCategoryAPI from "../../services/GetRestaurantsCategory/GetRestaurantsCategory";
import { GetDineInOutletsListAPI, GetDineInOutletsAPI, GetDineInOutletsTypeAPI, GetOutletsTypeAPI} from "../../services/GetDineInOutlets/GetDineInOutlets";
import UserTraction from "../../services/UserTraction/UserTraction";
import GetImageAPI from "../../services/GetCarouselImg/GetCarouselImg";
import OutletCard from "../../components/outlet-card/outlet-card";

const style = {
  height: 300, //Style for lottie animation
};

const Explore = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [restaurantType, setRestaurantType] = useState([]);
  const [restaurantList, setRestaurantList] = useState([]);
  const [carouselImg, setCarouselImg] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [cityName, setCityName] = useState("");
  const [localityName, setLocalityName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState('View All');
  const walletReward = useSelector((state) => state.wallet.coins);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchVisible, setIsSearchVisible] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [searchTimeout, setSearchTimeout] = useState(null);

  useEffect(() => {
    window.history.pushState(null, '', '/explore'); 
    window.addEventListener('popstate', handleBack);
    return () => {
      window.removeEventListener('popstate', handleBack);
    };
  }, []);

  const handleRestaurantDetail = ({outletId, outletNo}) => {
    let selectedOutletId = outletId ? outletId : outletNo;
    userTraction(selectedOutletId);
    navigate(pageUrl.OUTLET_DETAIL, {
      state: outletId ? { outletId: outletId } : { outletNo: outletNo },
      // state: { outletId: outletId, outletNo: outletNo},
    });
  };

  const userTraction = async (selectedId) => {
    let EventNo = 5;
    let SelectedOutlet = selectedId;
    try {
      const response = await UserTraction({
        EventNo: EventNo,
        SelectedOutlet: SelectedOutlet 
      });
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const UserTractionAPI = async (selectedOutletType) => {
    let EventNo = 3;
    try {
      const response = await UserTraction({
        EventNo: EventNo,
        OutletType: selectedOutletType
      });
    } catch (error) {
      console.error('API error:', error);
    }
  };


  const handleBack = () => {
    setIsModalOpen(true)
  };

  const handleOk = () => {
    // navigate('/exitpwa')
    let exitType = sessionStorage.getItem('isExit');
    if(exitType){
      navigate('/exitpwa?isExit=bank')
    }else{
      navigate('/exitpwa')
    }
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    return
  }

  useEffect(() => {
    const getCity = sessionStorage.getItem("city");
    const getLocality = sessionStorage.getItem("locality");
    const storedCity = sessionStorage.getItem("apiCityValue");
    const storedLocality = sessionStorage.getItem("apiLocalityValue");
    const storedRestoList = sessionStorage.getItem("storedRestoList");
    const storedRestoType = sessionStorage.getItem("storedRestoType");
    if(storedCity && storedLocality && getCity && getLocality && getLocality === storedLocality && getCity === storedCity && storedRestoList && storedRestoType){
      setRestaurantList(JSON.parse(storedRestoList))
      setRestaurantType(JSON.parse(storedRestoType))
    }else{
      getRestaurantList();
      getRestaurantCategories();
    }
    setCityName(getCity);
    setLocalityName(getLocality);
    getCarouselImage();
  }, []);

  const getRestaurantCategories = useCallback(async () => {
    try {
      const responseData = await GetRestaurantsCategoryAPI();
      if(responseData) {
        sessionStorage.setItem("storedRestoType",JSON.stringify(responseData))
      }
      setRestaurantType(responseData);
    } catch (error) {
      console.log("Category Type Error:", error);
    }
  },[]);

  const getCarouselImage = useCallback( async() => {
    try{
      const apiResp = await GetImageAPI();
      // console.log("Carousel Image Response :",apiResp);
      setCarouselImg(apiResp)
    }catch(e){
      console.log("Error calling carousel API :",e);
    }
  }, [])

  const handleSearch = () => {
    setIsSearchVisible(!isSearchVisible)
  }

  const handleSearchChange = (event) => {
    const searchQuery = event.target.value;
    setSearchQuery(searchQuery);  // Update the search query state
  
    if (searchTimeout) {
      clearTimeout(searchTimeout);  // Clear the previous timeout if the user types again
    }
  
    // Set a new timeout to trigger the API call after 3 seconds of no typing
    setSearchTimeout(
      setTimeout(() => {
        if(searchQuery!=""){
          userSearchTraction(searchQuery);  // Call the search tracking function after 3 seconds
        }
      }, 3000)
    );
  };

  const userSearchTraction = async (searchedOutlet) => {
    let EventNo = 4;
    try {
      const response = await UserTraction({
        EventNo: EventNo,
        SearchText: searchedOutlet
      });
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const filteredRestaurants = restaurantList.filter((restaurant) =>
    restaurant.outletName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    restaurant.locality.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const onLocationChange = () => {
    sessionStorage.setItem("fromPage","explore");
    navigate("/search-location");
  };

  const getRestaurantList = useCallback(async () => {
    setIsLoader(true)
    const cityValue = sessionStorage.getItem("city") || '';
    const localityValue = sessionStorage.getItem("locality") || '';
    const localityData = sessionStorage.getItem("localityValue") || '';
    // console.log("Locality Data in Explore :",localityData)
    try {
      const restaurantData = await GetDineInOutletsAPI(localityData);
      if(restaurantData){
        sessionStorage.setItem("apiCityValue",cityValue);
        sessionStorage.setItem("apiLocalityValue",localityValue);
        sessionStorage.setItem("storedRestoList",JSON.stringify(restaurantData));
      }
      setRestaurantList(restaurantData);
      setIsLoader(false)
      // console.log("Restaurant List Resp :", restaurantData);
    } catch (error) {
      console.log("Restaurant List Error :", error);
      setIsLoader(false)
    }
  },[]);

  const handleRestaurantCategory = async (categoryName) => {
    setIsLoader(true)
    try {
      const outletLocality = sessionStorage.getItem("localityValue") || '';
      const restaurantData = await GetOutletsTypeAPI(categoryName, outletLocality);
      setRestaurantList(restaurantData);
      setIsLoader(false)
      UserTractionAPI(categoryName);
      // console.log("restaurantCategory---", restaurantData);
    } catch (error) {
      console.log("restaurant type---", error);
      setIsLoader(false)
    }
  };

  const handleCategoryClick = (categoryName) => {
    setSelectedCategory(categoryName);
    if (categoryName === 'View All') {
      getRestaurantList();
    } else {
      handleRestaurantCategory(categoryName);
    }
  };

  const carousel_settings = {
    showArrows: false,
    interval: 4000,
    dynamicHeight: false,
    stopOnHover: false,
    infiniteLoop: true,
    showStatus: false,
    transitionTime: 700,
    showThumbs: false,
    showIndicators: true,
    swipeable: true,
    emulateTouch: true,
    autoPlay: true,
  };

  const activeImages = carouselImg.filter(item => item.active);

  const handleCarouselClick = (href) => {
    if (href.includes(";")) {
      const [typePart, idPart] = href.split(";");
      const type = typePart.split("=")[1];
      const id = idPart.split("=")[1];
      
      if (type === "outlet") {
        handleRestaurantDetail({outletNo: id});
      } else if (type === "category") {
        handleCategoryClick(id);
      } else {
        console.log("Unknown type:", type);
      }
    } else {
      console.log("Unknown href format:", href);
    }
  };

  return (
    <div className="explore-page">
      {isLoader && <Loader />}
      <div className="header-top">
        <Header
          coin={walletReward}
          onClick={handleBack}
          city={cityName}
          location={localityName}
          searchIcon={handleSearch}
          locationChange={onLocationChange}
          exitButton={true}
        />
      </div>
      {searchQuery === "" && activeImages.length > 0 && (
        <div className="carousel-section">
          <div className="carousel-container">
            <Carousel {...carousel_settings}>
              {activeImages.map((item, index) => (
                <div key={index} onClick={() => handleCarouselClick(item.href)}>
                    <img src={item.image} alt={`carousel-${index}`}/>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      )}
      {/* {isSearchVisible&&  */}
        <div className="searchbar-section">
          <SearchField stickeySearch={true} onChange={handleSearchChange} />
        </div>
      {/* } */}
      {restaurantType && restaurantType.length > 0 && (
        <div className="category-section">
          <CategoryCard
            cardText="View All"
            isSelected={selectedCategory === 'View All'}
            onClick={() => handleCategoryClick('View All')}
          />
          {restaurantType?.map((category, index) => {
            return (
              <CategoryCard
                key={index}
                imgSrc={CardImg}
                cardText={category.name}
                isSelected={selectedCategory === category.name}
                onClick={() => handleCategoryClick(category.name)}
              />
            );
          })}
        </div>
      )}
      <div className="outlet-list-section">
        {filteredRestaurants?.map((outlet, index) => {
          return (
            <OutletCard
              key={index}
              outetImg={outlet?.outletMedias[0]?.mediaPath}
              // outletName={handleExploreOutletName(outlet?.outletName)}
              outletName={outlet?.outletName}
              outletType={outlet?.type}
              outletRate={outlet?.avgTowPrice}
              outletPlace={outlet?.locality}
              outletTime={outlet?.timings}
              //onClick={() => handleRestaurantDetail({outletId: outlet.outletId})} //Old one
              onClick={() => handleRestaurantDetail({outletNo: outlet.outletNo})}
              outetOffer={outlet?.outletOffers[0]}
            />
          );
        })}
      </div>
      {!isLoader & (filteredRestaurants?.length === 0) ? (
        <div className="noRestoImg">
          <Lottie style={style} loop={true} animationData={NotFound} />
          <span className="noRestoText">No Outlets!!</span>
        </div>
      ) : null}
      <TwoBtnModal
        isOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCloseModal}
        message={{ title: "", text: "Do you want to exit the Application?" }}
        icon=""
        className=""
        showCancelButton={true} 
      />
      <Footer />
    </div>
  );
};

export default Explore;
